export default __webpack_public_path__ + "locales/it/HotkeysPanel.json?hash=09cb92d15d6db3b953b2158576ea577e";